'use client'
import {
  ContentfulButton_default
} from "./chunk-K3ITZBKW.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/components/button/ShareContentfulButton.tsx
import { twMerge } from "tailwind-merge";
import { ShareModal } from "@wbk/ui";
import { jsx } from "react/jsx-runtime";
var ShareContentfulButton = ({ section, type = "default", className }) => {
  var _a, _b;
  const shareLink = (_b = (_a = section == null ? void 0 : section.webLinksCollection) == null ? void 0 : _a.items) == null ? void 0 : _b.find((link) => link.id === "share");
  const isShareButtonVisible = !!shareLink;
  if (!isShareButtonVisible) return null;
  const isMini = type === "mini";
  return /* @__PURE__ */ jsx(
    ShareModal,
    {
      data: {
        title: section == null ? void 0 : section.title,
        text: section == null ? void 0 : section.subtitle
      },
      hideText: true,
      render: ({ share }) => /* @__PURE__ */ jsx(
        ContentfulButton_default,
        {
          link: __spreadProps(__spreadValues({}, shareLink), { href: "#" }),
          hideText: isMini,
          shape: shareLink == null ? void 0 : shareLink.shape,
          theme: shareLink == null ? void 0 : shareLink.theme,
          className: twMerge(
            isMini && "absolute right-4 top-4 h-12 w-12 rounded-full p-0",
            className
          ),
          onClick: () => share()
        }
      )
    }
  );
};
var ShareContentfulButton_default = ShareContentfulButton;

export {
  ShareContentfulButton_default
};
//# sourceMappingURL=chunk-ALSTKEM5.mjs.map